import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, auth, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("Admin@honeystone.uk");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      auth.setSession(data.token, data.user);
      nav("/admin");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-10 hs-fade" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-[#E5E0D8] bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]" data-testid="admin-login-form">
        <div className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#E3EBDA] text-[#3C5A3F] mb-4">
          <Lock size={20} weight="fill" />
        </div>
        <h1 className="font-[Outfit] text-2xl font-semibold text-[#2C3E35] tracking-tight">Admin sign in</h1>
        <p className="mt-1 text-sm text-[#73777B]">For the Honeystone business owner.</p>

        <div className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" data-testid="admin-email" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" data-testid="admin-password" />
          </div>
          {err && <p className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-md px-3 py-2" data-testid="admin-login-error">{err}</p>}
          <Button type="submit" disabled={busy} className="w-full rounded-full bg-[#4F6F52] hover:bg-[#3C5A3F] text-white h-11" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </div>
      </form>
    </div>
  );
}
